/* ============================================================
   BSU-Gutschein im Warenkorb (Stand 06.10.2026, Entscheidungen Sales).
   MUSS als LETZTE der Warenkorb-Dateien geladen werden (nach
   gc-lieblings.js): legt sich um gcEnforceMengenrabatt().

   Wann ist ein Warenkorb "BSU"?
   Warenkorb-Attribut bsu_flow = true UND kein anderer Partner-/
   Zielgruppenmodus aktiv (Aposanitas, LieblingsApotheken, Dental,
   gesund leben, Alliance Healthcare). Der zuletzt geoeffnete
   Partnerlink gilt. Gesetzt wird bsu_flow nur durch den DIREKTEN
   Aufruf von /pages/bsu bzw. /bsu (sections/bsu-configurator.liquid).

   Logik: In DIESER Bestellung wird nichts abgezogen. Mit Igloo im
   Warenkorb gibt es einen Warengutschein fuer die NAECHSTE Bestellung:
     Igloo + 1 Testbox      -> 100 EUR (BSU100)
     Igloo + 2 Testboxen    -> 200 EUR (BSU200)
     Igloo + ab 3 Testboxen -> 300 EUR (BSU300)
   Die Stufe steht als Attribut "BSU-Gutschein" an der Bestellung;
   damit verschickt das Team den passenden Code. Die Codes gelten bis
   31.12.2027, einmal pro Kunde, und werden im normalen Shop
   eingeloest. Im BSU-Warenkorb selbst werden sie entfernt (der
   Gutschein gilt erst fuer die naechste Bestellung).

   Stufen zusaetzlich in: Shopify-Rabatten, snippets/gc-bsu-cart.liquid,
   sections/main-cart.liquid (Pflicht-Checkbox). Der Rechner
   (assets/bsu-configurator.js) liest window.gcBsu.
   ============================================================ */
window.gcBsu = Object.assign({
  tiers: [                              /* absteigend sortiert */
    { min: 3, amount: 300, code: 'BSU300' },
    { min: 2, amount: 200, code: 'BSU200' },
    { min: 1, amount: 100, code: 'BSU100' }
  ],
  validUntil: '31.12.2027',
  page: '/pages/bsu',
  attrName: 'BSU-Gutschein'
}, window.gcBsu || {});

/* Gutscheinstufe fuer Geraet + n Testboxen (oder null) */
function gcBsuTier(deviceQty, boxQty){
  if(!(deviceQty >= 1)) return null;
  const tiers = window.gcBsu.tiers;
  for(let i = 0; i < tiers.length; i++){
    if(boxQty >= tiers[i].min) return tiers[i];
  }
  return null;
}

/* Text fuer das Bestell-Attribut (leer = kein Gutschein) */
function gcBsuAttrValue(tier){
  if(!tier) return '';
  return tier.code + ' – ' + tier.amount + ' € Warengutschein für die nächste Bestellung (einlösbar bis ' + window.gcBsu.validUntil + ')';
}

/* Ist der Warenkorb im BSU-Modus? Andere Modi haben Vorrang, weil sie
   nur durch einen spaeter geoeffneten Partnerlink gesetzt sein koennen. */
function gcBsuActive(attrs){
  attrs = attrs || {};
  if(attrs.bsu_flow !== 'true') return false;
  if(attrs.aposanitas_flow === 'true') return false;
  if(attrs.lieblings_flow === 'true') return false;
  if(attrs.dental_flow === 'true') return false;
  if(attrs.partner_flow === 'gesundleben' || attrs.partner_flow === 'ahd') return false;
  return true;
}

async function gcEnforceBsu(){
  try{
    const C = window.gcBsu;
    const root = window.Shopify.routes.root;
    const res = await fetch(root + 'cart.js');
    const cart = await res.json();
    const attrs = cart.attributes || {};

    if(!gcBsuActive(attrs)){
      /* Nicht (mehr) BSU: nur ein liegengebliebenes Gutschein-Attribut
         aufraeumen. Die BSU-Codes selbst bleiben unangetastet - sie
         werden ja im normalen Shop eingeloest. */
      if(attrs[C.attrName]){
        const a = {}; a[C.attrName] = '';
        await fetch(root + 'cart/update.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ attributes: a })
        });
      }
      return;
    }

    let deviceQty = 0, boxQty = 0;
    cart.items.forEach(i => {
      if(i.product_type === 'Geraet') deviceQty += i.quantity;
      if(i.product_type === 'Testkit') boxQty += i.quantity;
    });
    const tier = gcBsuTier(deviceQty, boxQty);

    const body = {};
    const attrUpdate = {};
    const want = gcBsuAttrValue(tier);
    if((attrs[C.attrName] || '') !== want) attrUpdate[C.attrName] = want;
    if(attrs.Partner !== 'BSU') attrUpdate.Partner = 'BSU';
    if(attrs.startbonus_flow) attrUpdate.startbonus_flow = '';
    if(Object.keys(attrUpdate).length) body.attributes = attrUpdate;

    /* BSU-Codes gelten erst fuer die naechste Bestellung -> hier raus */
    const own = C.tiers.map(t => t.code.toUpperCase());
    const current = (cart.discount_codes || []).map(d => d.code);
    const keep = current.filter(c => own.indexOf(c.toUpperCase()) === -1);
    if(keep.length !== current.length) body.discount = keep.join(',');

    const changeCodes = Object.prototype.hasOwnProperty.call(body, 'discount');
    if(!changeCodes && !body.attributes) return;

    await fetch(root + 'cart/update.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(body)
    });
    if(typeof gcRefreshCartSection === 'function') await gcRefreshCartSection();
  } catch(err){
    console.error('BSU-Check fehlgeschlagen:', err);
  }
}

(function(){
  const orig = window.gcEnforceMengenrabatt;
  window.gcEnforceMengenrabatt = async function(){
    if(typeof orig === 'function') await orig.apply(this, arguments);
    await gcEnforceBsu();
  };
})();
